import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Select } from '../inputs';
import { useTextHeadingDropdown } from '../../hooks/notes/use_text_heading_dropdown';
import { AppText } from '../typography';
import { ReactSelectComponents } from '../../util';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { styled, Theme } from '../../styles';
import { toolbarButtonStyles } from './styles';
import { AppIcon } from '../icons';
import { Row } from '../layout';
export function TextHeadingDropdown() {
    const { headingFormatOptions, isLoading, onSelectOption, isDropdownDisabled } = useTextHeadingDropdown();
    const { textHeadingDropdownContext } = useNotesToolbarContext();
    const isDisabled = isDropdownDisabled || isLoading;
    return (_jsx(Select, { externallyControlledOption: textHeadingDropdownContext.activeHeadingOption, isDisabled: isDisabled, options: headingFormatOptions, isSearchable: false, onSelect: onSelectOption, components: {
            Input: () => null,
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
            SingleValue: HeaderSelection,
        }, formatOptionLabel: CustomLabel, styles: selectionStyles }));
}
const HeaderSelection = (props) => {
    return (_jsx(ReactSelectComponents.SingleValue, { ...props, children: _jsx(SelectedHeading, { "data-testid": "selected-heading-notes", children: props.data.label }) }));
};
const selectionStyles = {
    container: base => ({
        ...base,
        marginRight: '0.375rem',
    }),
    control: (base, props) => ({
        ...base,
        width: '6.5rem',
        height: toolbarButtonStyles.height,
        minHeight: toolbarButtonStyles.height,
        border: 'none',
        cursor: 'pointer',
        background: 'none',
        boxShadow: 'none',
        color: props.isDisabled ? Theme.colors.grey30 : Theme.colors.grey90,
        fill: props.isDisabled ? Theme.colors.grey30 : Theme.colors.red50,
        ':hover': {
            color: props.isDisabled ? Theme.colors.grey30 : Theme.colors.blue50,
            cursor: props.isDisabled ? 'not-allowed' : 'pointer',
        },
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px',
        overflow: 'unset',
    }),
    dropdownIndicator: (base, { selectProps }) => ({
        ...base,
        padding: '0px',
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        transition: 'all .2s ease',
        color: 'inherit',
        ':hover': { color: 'inherit' },
    }),
    menu: base => ({
        ...base,
        marginTop: '1.1rem',
        borderRadius: '0.5rem',
        width: '12.5rem',
    }),
    menuList: base => ({
        ...base,
        padding: 0,
    }),
    option: base => ({
        ...base,
        padding: '0.5rem 0',
        overflow: 'hidden',
        backgroundColor: 'none',
        color: 'inherit',
        ':hover': { backgroundColor: Theme.colors.blue05, cursor: 'pointer' },
    }),
    singleValue: base => ({
        ...base,
        color: 'inherit',
        ':hover': { color: 'inherit' },
    }),
};
const CustomLabel = (data, { selectValue }) => {
    const { label, optionLabelStyle } = data.value;
    const isSelected = selectValue.some((selectValue) => selectValue.label === label);
    const paddingLeft = isSelected ? '0.5rem' : '2.55rem';
    return (_jsxs(Row, { alignItems: "center", id: "row", style: { gap: '.56rem', paddingLeft: paddingLeft }, children: [isSelected && _jsx(AppIcon, { name: "DoneIcon", size: "small", color: Theme.colors.black }), _jsx(AppText, { headingFontFamily: optionLabelStyle.headingFontFamily, size: optionLabelStyle.fontSize, "data-testid": `heading-format-dropdown-label-${label}`, children: label })] }));
};
const SelectedHeading = styled(AppText)({
    textAlign: 'center',
    fontSize: '0.875rem',
    color: 'inherit',
});
//# sourceMappingURL=text_heading_dropdown.js.map